"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    registeredAddress: 'Pistonheads Holdco Limited, c/o Legalinx Limited, 3rd Floor, 207 Regent St, London W1B 3HH, United Kingdom',
};
//# sourceMappingURL=copy.js.map